export const environment = {
  apiHttp: 'https://',
  apiWs: 'wss://',
  apiUrl: 'finthesis-back-dev.fromscratch-apis.com',
  accessToken: '5DSy6T3Bl4cb7b1b',
  debug: true,
};
